import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from '../plugins/vuetify'
import i18n from './i18n'  // импортируем
import { createHead } from '@vueuse/head'

const head = createHead()

createApp(App)
    .use(store)
    .use(router)
    .use(vuetify)
    .use(head)
    .use(i18n)  // подключаем
    .mount('#app')